(() => {
  'use strict';
  if (window.ArohaOfferDisplay) return;
  const update = () => {
    try {
    const banner = document.querySelector('aroha-labour-weekend');
    const start = Date.parse(banner?.dataset.start);
    const end = Date.parse(banner?.dataset.end);
    const now = Date.now();
    const validDates = Number.isFinite(start) && Number.isFinite(end) && start < end;
    // Terminal hide also works when the separate banner enhancement is unavailable.
    if (banner && (!validDates || now >= end)) banner.hidden = true;
    const inWindow = banner?.dataset.ready === 'true' && validDates && now >= start && now < end;
    const market = window.ArohaMarket;
    document.querySelectorAll('[data-aa-offer-price]').forEach(price => {
      const validMarket = inWindow && price.dataset.country === 'NZ' && price.dataset.currency === 'NZD'
        && window.Shopify?.currency?.active === 'NZD'
        && typeof market?.isCurrent === 'function'
        && market.isCurrent({country:price.dataset.country, currency:price.dataset.currency, themeId:price.dataset.themeId}) === true;
      const sale = price.querySelector('[data-shop-sale]');
      if (!sale) return;
      const live = !!(inWindow && validMarket);
      sale.hidden = !live;
      price.querySelector('[data-shop-native]').hidden = live;
    });
    document.querySelectorAll('[data-aa-shop]').forEach(shop => {
      const live = [...shop.querySelectorAll('[data-shop-sale]')].some(node => !node.hidden);
      shop.querySelectorAll('[data-shop-offer]').forEach(note => { note.hidden = !live; });
    });
    } catch (_) {
      reset();
    }
  };
  const reset = () => {
    document.querySelectorAll('[data-shop-sale], [data-shop-offer]').forEach(node => {node.hidden = true;});
    document.querySelectorAll('[data-shop-native]').forEach(node => {node.hidden = false;});
  };
  window.ArohaOfferDisplay = {update, reset};
  update();
  setInterval(update, 1000);
  document.addEventListener('visibilitychange', update);
  document.addEventListener('shopify:section:load', update);
  window.addEventListener('pageshow', update);
  document.addEventListener('submit', event => {
    if (event.target?.action && new URL(event.target.action).pathname.endsWith('/localization')) reset();
  }, true);
})();
